import { generateBreadcrumbs } from '@bv/utils/route/breadcrumbs/generate-breadcrumbs';
import { aiRoutesGenerator } from '@bvai/router';

import { bvaiConfig } from '@/bvai.config';

import type { RouteRecordRaw } from '@bv/router';

const aiBreadcrumbs = generateBreadcrumbs({
  label: 'AI',
  route: { name: 'ai' },
});

const chat_ai_route = {
  path: '/ai',
  name: 'ai',
  redirect: { name: 'ai-agents-performance' },
  meta: {
    header: {
      title: 'GLOBAL.NAVS.ai_trans',
      icon: 'bvi-ai-solid',
    },
    sidebar: [
      {
        icon: 'bvi-dashboard',
        title: 'global.sidebar.agents_performance_trans',
        route: { name: 'ai-agents-performance' },
        permissions: 'read-ai-agents',
      },
      {
        icon: 'bvi-ai-solid',
        title: 'global.sidebar.my_agents_trans',
        route: { name: 'ai-agents-list' },
        permissions: 'read-ai-agents',
      },
      {
        icon: 'bvi-book',
        title: 'global.sidebar.knowledge_base_trans',
        route: { name: 'ai-agents-knowledge-base-list' },
        permissions: 'read-ai-knowledge-base',
      },
      {
        icon: 'bvi-chart-line',
        title: 'global.sidebar.analysis_report_trans',
        route: { name: 'ai-analysis-report' },
        permissions: 'read-ai-agents',
      },
      {
        icon: 'bvi-history',
        title: 'global.sidebar.credit_history_trans',
        route: { name: 'ai-credit-history' },
        permissions: 'read-ai-agents',
      },
    ],
  },
  children: [
    {
      path: 'ai-analysis-report',
      name: 'ai-analysis-report',
      component: () => import('@/views/System/Ai/AnalysisReport/AgentsAnalysisView.vue'),
      meta: {
        permissions: 'read-ai-agents',
        breadcrumbs: aiBreadcrumbs({
          label: 'global.sidebar.analysis_report_trans',
          route: { name: 'ai-analysis-report' },
        }),
      },
    },
    {
      path: 'agents/performance',
      name: 'ai-agents-performance',
      component: () => import('@/views/System/Ai/Pages/AgentsPerformanceView.vue'),
      meta: {
        permissions: 'read-ai-agents',
        breadcrumbs: aiBreadcrumbs({
          label: 'global.sidebar.agents_performance_trans',
          route: { name: 'ai-agents-performance' },
        }),
      },
    },
    {
      path: 'credit-history',
      name: 'ai-credit-history',
      component: () => import('@/views/System/Ai/Pages/CreditHistoryView.vue'),
      meta: {
        permissions: 'read-ai-agents',
        breadcrumbs: aiBreadcrumbs({
          label: 'global.sidebar.credit_history_trans',
          route: { name: 'ai-credit-history' },
        }),
      },
    },
  ],
} as unknown as RouteRecordRaw;

const ai_routes = aiRoutesGenerator(chat_ai_route, {
  exclude_routes: bvaiConfig.exclude_routes,
});

export default [ai_routes];
